/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Pagination, Keyboard, A11y} from 'swiper/modules';

const carousels = document.querySelectorAll('.card-swiper-container');

carousels.forEach((carousel, index) => {

    let slider = carousel.querySelector('.card-swiper');
    let pagination = carousel.querySelector('.swiper-pagination');
    let prev = carousel.querySelector('.swiper-button-prev');
    let next = carousel.querySelector('.swiper-button-next');

    const cardSwiper = new Swiper(slider, {
        modules: [Navigation, Pagination, Keyboard, A11y ],
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 1000,
        loop: false,
        loopAdditionalSlides: 1,
        keyboard: {
            enabled: true
        },
        pagination: {
            el: pagination,
            type: "progressbar"
        },
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1000: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 3,
                spaceBetween: 24,
            }
        }
    });

});


const featured = document.querySelectorAll('.featured-card-swiper-container');

featured.forEach((feature, index) => {

    let slider = feature.querySelector('.card-swiper');
    let pagination = feature.querySelector('.swiper-pagination');
    let prev = feature.querySelector('.swiper-button-prev');
    let next = feature.querySelector('.swiper-button-next');

    const featureSwiper = new Swiper(slider, {
        modules: [Navigation, Pagination, Keyboard, A11y ],
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 1000,
        loop: false,
        loopAdditionalSlides: 1,
        keyboard: {
            enabled: true
        },
        pagination: {
            el: pagination,
            type: "progressbar"
        },
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
        breakpoints: {
            600: {
                spaceBetween: 16,
            },
            1000: {
                spaceBetween: 24,
            },
            // when window width is >= 1200px
            1200: {
                spaceBetween: 24,
            }
        }
    });

});
